const validNum = {
  VALID_NUMBER: 'VALID_NUMBER',
};

export default validNum;
